import axios from 'axios'

import * as types from '../mutations-types'
import {GEO_URL} from '../../utils/endpoints'
import {clientIdFromAccessToken, resolveMapZoneMode} from '../../utils/clientId'
import {fetchZonesByIds} from '../../utils/api'

// const NEIGHBORHOOD_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=neighborhood&version=4`
// const COMUNE_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=commune&version=4`
const QUADRANT_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=quadrant&version=4`
const STATIONS_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=policeStation&version=4`
const DISTRICTS_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=policeDistrict&version=4`
const NEIGHBORHOOD_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=neighborhood&version=2`
const COMUNE_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=commune&version=2`
// const QUADRANT_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=quadrant&version=2`
// const STATIONS_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=policeStation&version=2`
// const DISTRICTS_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=policeDistrict&version=2`
// const QUADRANT_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=quadrant&chunk=10&version=2`
// const STATIONS_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=policeStation&chunk=10&version=2`
// const DISTRICTS_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=policeDistrict&chunk=10&version=2`

// const MUNICIPALITY_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=municipality&version=2`
const MUNICIPALITY_URL = `${GEO_URL}/search?id=7977,8586,8590,8574,8589,8577,8588,8576,7972,8575`
const FIREFIGHTERS_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=firefightersDivision&version=2`
const EMPAS_URL = `${GEO_URL}/areas?fields=geostring,id,name,type&type=empas&version=4`

async function loadAreas(url, clientIds) {
  const responses = await Promise.all(clientIds.map(clientId => axios.get(`${url}&client_id=${clientId}`)))
  const byId = new Map()
  responses.forEach(response => {
    const rows = Array.isArray(response.data) ? response.data : []
    rows.forEach(item => byId.set(item.id, item))
  })
  return Array.from(byId.values())
}
// const FIREFIGHTERS_URL = `https://strauss.seguridadenlinea.com/v1/geo/areas?fields=geostring,id,name,type&type=firefightersDivision&version=2`

const zoneFiltersModule = {
  namespaced: true,
  // STATE
  state: {
    firefighters: [],
    fullZoneMaps: null,
    zoneGeostrings: [],
    neighborhoods: [],
    comunes: [],
    quadrants: [],
    stations: [],
    districts: [],
    municipality: [],
    empas: [],
    galleryNeighborhoods: [],
    galleryCommunes: [],
    galleryQuadrants: [],
    galleryStations: [],
    galleryDistricts: []
  },
  // GETTERS
  getters: {
    getFirefighters: state => state.firefighters,
    fullZoneMaps: state => state.fullZoneMaps,
    getMunicipality: state => state.municipality,
    getEmpas: state => state.empas,
    zoneGeostrings: state => state.zoneGeostrings,
    getZoneGeostrings: state => {
      return state.zoneGeostrings.map(zone => {
        return {
          ...zone,
          path: window.google.maps.geometry.encoding.decodePath(zone.geostring)
        }
      })
    },
    getNeighborhoods: state => {
      return state.neighborhoods
    },
    getComunes: state => {
      return state.comunes
    },
    getQuadrants: state => {
      return state.quadrants
    },
    getStations: state => {
      return state.stations
    },
    getDistricts: state => {
      return state.districts
    },
    getGalleryNeighborhoods: state => {
      return state.galleryNeighborhoods
    },
    getGalleryComunes: state => {
      return state.galleryCommunes
    },
    getGalleryQuadrants: state => {
      return state.galleryQuadrants
    },
    getGalleryStations: state => {
      return state.galleryStations
    },
    getGalleryDistricts: state => {
      return state.galleryDistricts
    }
  },
  // ACTIONS
  actions: {
    async updateZoneFilters({commit}, {neighborhoods, communes, quadrants = [], stations = [], districts = []}
    ) {
      let zoneIds = []
      communes.map(commune => {
        zoneIds.push(commune.id)
      })
      neighborhoods.map(neighborhood => {
        zoneIds.push(neighborhood.id)
      })
      quadrants.map(quadrant => {
        zoneIds.push(quadrant.id)
      })
      stations.map(station => {
        zoneIds.push(station.id)
      })
      districts.map(district => {
        zoneIds.push(district.id)
      })
      zoneIds = zoneIds.join(',')

      const {data} = await fetchZonesByIds(zoneIds)
      return new Promise((resolve, reject) => {
        try {
          if ('error' in data) {
            commit(types.FETCH_ZONES_FILTERS)
            reject(data.error)
          } else {
            // console.log('ZONES DATA: ', data)
            commit(types.FETCH_ZONES_FILTERS, data)
            resolve()
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    /**
     * Metodo que pre-carga los datos de comunas, barrios, cuadrantes, estaciones y distritos con un numero minimo de items para mostrar en interfaz al momento de filrar por zonas
     * @param commit
     * @returns {Promise<void>}
     */
    async initializeFilters({commit, rootGetters, dispatch}) {
      const tokenClientId = rootGetters['auth/clientId'] || clientIdFromAccessToken()
      const mode = resolveMapZoneMode({
        tokenClientId,
        isAdmin: rootGetters['auth/adminRole'] !== null,
        roleAgencyIds: rootGetters['auth/role'] || [],
        agenciesTree: rootGetters.agenciesBase || []
      })
      if (mode !== rootGetters['auth/mapZoneMode']) {
        dispatch('auth/setMapZoneMode', mode, {root: true})
      }
      const otherClients = mode === 'gobernacion' ? [2] : [tokenClientId > 1 ? tokenClientId : 1]
      const sharedClients = mode === 'all' ? [1, 2] : otherClients
      const empasClients = mode === 'gobernacion' ? [2] : []
      const [neigborhoods, communes, quadrants, stations, districts, municipality, firefighters, empas] = await Promise.all([
        loadAreas(NEIGHBORHOOD_URL, otherClients),
        loadAreas(COMUNE_URL, otherClients),
        loadAreas(QUADRANT_URL, sharedClients),
        loadAreas(STATIONS_URL, sharedClients),
        loadAreas(DISTRICTS_URL, otherClients),
        loadAreas(MUNICIPALITY_URL, otherClients),
        loadAreas(FIREFIGHTERS_URL, otherClients),
        loadAreas(EMPAS_URL, empasClients)
      ])

      let geofencesIn = []
      if (rootGetters.getGeofences.length === 0) {
        geofencesIn = await dispatch('fetchGeofencesData', null, { root: true })
      }
      geofencesIn = rootGetters.getGeofences

      let fullMap = []
      const zones = [neigborhoods, communes, quadrants, stations, districts, municipality, firefighters, geofencesIn, empas]
      // console.log('ZONES', zones)
      for (let index = 0; index < zones.length; index++) {
        const preMap = []
        const element = zones[index]
        // console.log('ELEMENT: ', element.data)
        // element.data.forEach(item => {
        element.forEach(item => {
          const dupla = [item.id, item.name]
          preMap.push(dupla)
        })
        fullMap = fullMap.concat(preMap)
      }
      const fullZoneMap = new Map(fullMap)
      commit(types.SET_FULL_ZONES_MAP, fullZoneMap)

      commit(types.SET_NEIGHBORHOOD, neigborhoods)
      commit(types.SET_COMUNE, communes)
      commit(types.SET_QUADRANT, quadrants)
      commit(types.SET_STATIONS, stations)
      commit(types.SET_DISTRICTS, districts)
      commit(types.SET_MUNICIPALITY, municipality)
      commit(types.SET_GALLERY_NEIGHBORHOOD, neigborhoods)
      commit(types.SET_GALLERY_COMUNE, communes)
      commit(types.SET_GALLERY_QUADRANT, quadrants)
      commit(types.SET_GALLERY_STATIONS, stations)
      commit(types.SET_GALLERY_DISTRICTS, districts)
      commit(types.SET_FIREFIGHTERS, firefighters)
      commit(types.SET_EMPAS, empas)
    },
    setQuadrants({commit}, quadrants) {
      commit(types.SET_QUADRANT, quadrants)
    },
    setStations({commit}, stations) {
      commit(types.SET_STATIONS, stations)
    },
    setDistricts({commit}, districts) {
      commit(types.SET_DISTRICTS, districts)
    },
    setGalleryQuadrants({commit}, quadrants) {
      commit(types.SET_GALLERY_QUADRANT, quadrants)
    },
    setGalleryStations({commit}, stations) {
      commit(types.SET_GALLERY_STATIONS, stations)
    },
    setGalleryDistricts({commit}, districts) {
      commit(types.SET_GALLERY_DISTRICTS, districts)
    }
  },
  // MUTATIONS
  mutations: {
    [types.SET_FIREFIGHTERS](state, firefighters) {
      state.firefighters = firefighters
    },
    [types.SET_EMPAS](state, empas) {
      state.empas = empas
    },
    [types.SET_FULL_ZONES_MAP](state, data) {
      state.fullZoneMaps = data
    },
    [types.SET_MUNICIPALITY](state, municipality) {
      const municipalitySort = municipality.sort(function(a, b) {
        var textA = a.name.toUpperCase()
        var textB = b.name.toUpperCase()
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
      })
      state.municipality = municipalitySort
    },
    [types.FETCH_ZONES_FILTERS](state, zoneGeostrings = []) {
      state.zoneGeostrings = zoneGeostrings
    },
    [types.SET_NEIGHBORHOOD](state, neighborhoods) {
      state.neighborhoods = neighborhoods
    },
    [types.SET_COMUNE](state, comunes) {
      state.comunes = comunes
    },
    [types.SET_QUADRANT](state, quadrants) {
      state.quadrants = quadrants
    },
    [types.SET_STATIONS](state, stations) {
      state.stations = stations
    },
    [types.SET_DISTRICTS](state, districts) {
      state.districts = districts
    },
    [types.SET_GALLERY_NEIGHBORHOOD](state, neighborhoods) {
      state.galleryNeighborhoods = neighborhoods
    },
    [types.SET_GALLERY_COMUNE](state, comunes) {
      state.galleryCommunes = comunes
    },
    [types.SET_GALLERY_QUADRANT](state, quadrants) {
      state.galleryQuadrants = quadrants
    },
    [types.SET_GALLERY_STATIONS](state, stations) {
      state.galleryStations = stations
    },
    [types.SET_GALLERY_DISTRICTS](state, districts) {
      state.galleryDistricts = districts
    }
  }
}

export default zoneFiltersModule



// WEBPACK FOOTER //
// ./src/store/modules/zoneFiltersModule.js